const RecoveryForm: React.FC<{
  recoveryFormData: any;
  onRecoveryChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRecoverySubmit: (e: React.FormEvent) => void;
  isEditingRecovery: boolean;
  onCancel: () => void;
}> = ({ recoveryFormData, onRecoveryChange, onRecoverySubmit, isEditingRecovery, onCancel }) => (
  <form onSubmit={onRecoverySubmit}>
    <div className="grid grid-cols-2 gap-4 mt-4">
      <div className="flex flex-col">
        <label className="referral-form-label">
          Registration Number
        </label>
        <input
          type="text"
          placeholder="Enter registration number"
          className="referral-form-field"
          name="asset_recovery_request_registration_number"
          value={recoveryFormData.asset_recovery_request_registration_number || ""}
          onChange={onRecoveryChange}
        />
      </div>

      <div className="flex flex-col">
        <label className="referral-form-label">
          Registration Date
        </label>
        <input
          type="date"
          className="referral-form-field"
          name="asset_recovery_request_date_registrar"
          value={recoveryFormData.asset_recovery_request_date_registrar || ""}
          onChange={onRecoveryChange}
        />
      </div>
    </div>

    <div className="flex justify-end mt-6 gap-4">
      {isEditingRecovery && (
        <button
          type="button"
          onClick={onCancel}
          className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
        >
          Cancel
        </button>
      )}
      <button
        type="submit"
        className="referral-form-button text-white"
        style={{ padding: "10px", fontSize: "14px" }}
      >
        {isEditingRecovery ? "Update" : "Add"} Details
      </button>
    </div>
  </form>
);

export default RecoveryForm